import styled, { css } from 'styled-components';
import { palette, theme } from 'styled-tools';

const tS = {
  trackSize: theme('ToggleSwitch.trackSize'),
  trackGap: theme('ToggleSwitch.trackGap'),
  border: theme('ToggleSwitch.border'),
  checkedColor: theme('ToggleSwitch.checkedColor'),
  width: theme('ToggleSwitch.width'),
  height: theme('ToggleSwitch.height'),
  borderRadius: theme('ToggleSwitch.borderRadius'),
  borderWidth: theme('ToggleSwitch.borderWidth'),
  transition: theme('ToggleSwitch.transition'),
};

export const Container = styled.label`
  display: inline-block;
`;

export const ToggleSwitch = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 38px;
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    css`
       {
        opacity: 0.4;
        cursor: not-allowed;
      }
    `};

  input {
    display: none;
    &:checked + span.dot {
      background-color: ${({ disabled }) =>
        disabled
          ? palette('switchCheckedDisabledColor')
          : palette('switchCheckedColor')};

      border-color: transparent;
      &:after {
        background-color: ${palette('switchTrackCheckedColor')};
        left: calc(
          100% - ${tS.trackSize} - ${tS.trackGap} - ${tS.borderWidth} * 2
        );
      }
    }

    &:focus + span {
      box-shadow: 0 0 1px ${palette('switchCheckedColor')};
    }

    &:disabled + span {
      cursor: not-allowed;
    }
  }

  span.dot {
    position: relative;
    display: inline-block;
    width: ${tS.width};
    height: ${tS.height};
    margin-right: ${theme('spacing.xs')};
    background-color: ${palette('switchColor')};
    border-radius: ${tS.borderRadius};
    border-width: ${tS.borderWidth};
    border-style: solid;
    border-color: ${palette('switchBorderColor')};
    transition: ${tS.transition};
    transition-property: background-color, border-color;

    &:after {
      left: ${tS.trackGap};
      top: ${tS.trackGap};
      position: absolute;
      content: ' ';
      border-width: ${tS.borderWidth};
      border-style: solid;
      border-color: transparent;
      height: ${tS.trackSize};
      width: ${tS.trackSize};
      background-color: ${palette('switchTrackColor')};
      transition: ${tS.transition};
      transition-property: background-color, left, border-color;
      border-radius: 50%;
    }
  }
`;
